import { useState } from 'react';
import { DEFAULT_STORE_DATA } from '../Data/DefaultStoreData';
import { useDispatch } from 'react-redux';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '../../constants/ActionTypes';
import { useToast } from 'context/tostifyContext';

const useStockTransactionsForm = (currentData, handleConsume) => {
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const [transactionData, setTransactionData] = useState(DEFAULT_STORE_DATA);

  const handleInput = (name, value) => {
    setTransactionData(prevState => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (transactionData.quantity > currentData?.qtY_DELIVERED) {
      showToast('Consumed Quantity cannot be greater than delivered quantity!', 'error');
      return;
    }

    try {
      const payload = {
        ...transactionData,
        pO_ReqNumber: currentData?.ordeR_NUMBER,
        stock: currentData?.stocK_CODE,
        transactionType: 'consume',
      };

      dispatch({ type: FETCH_START });
      customAxios
        .post(`/PO/AddStockTransactions`, payload, { headers: authHeader() })
        .then(data => {
          if (data.status == 200) {
            showToast('Transaction created successfully', 'success');
            setTransactionData(DEFAULT_STORE_DATA);
            setTimeout(() => {
              handleConsume(currentData);
            }, 100);
          } else {
            showToast('Failed to create stock transaction Data ', 'error');
          }
          dispatch({ type: FETCH_SUCCESS });
        })
        .catch(error => {
          console.log(error);
          showToast('Failed to Create new stock transaction ', 'error');
          dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
        });
    } catch (error) {
      console.log(error);
    }
  };

  return {
    transactionData,
    handleInput,
    handleSubmit,
  };
};

export default useStockTransactionsForm;
